import Vue from 'vue';
import VueRouter from 'vue-router';
import SingersPage from '../views/SingersPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: SingersPage,
  },
  {
    path: '/singers',
    redirect: '/',
  },
];

const router = new VueRouter({
  routes,
});

// 根据路由名称更新页面标题
router.beforeEach((to, from, next) => {
  document.title = '欢迎来到予爱の世界';
  next();
});

export default router;